<template>
  <div class="login-choose-layout">
    <div class="header" v-if="hasMenu"> 
      <img src="@/assets/logo_white.png" class="logo" />
      快麦通
    </div>
    <div class="body">
      <div class="title">请选择您的身份</div>
      <div class="block-choose">
        <div class="card" @click="to(1)">
          <div class="img">
            <img src="@/assets/choose_supplier.png" class="supplier" />
          </div>
          <div class="title">
            供销商
          </div>
          <div class="des">有货源的工厂、档口、品牌商、商家</div>
          <div class="choose-btn">
            <PrimaryBtn>我是供销商</PrimaryBtn>
          </div>
        </div>
        <div class="card" @click="to(2)">
          <div class="img">
            <img src="@/assets/choose_distributor.png" class="distributor" />
          </div>
          <div class="title">
            分销商
          </div>
          <div class="des">有渠道的mcn机构、主播、微商、商家等</div>
          <div class="choose-btn">
            <PrimaryBtn>我是分销商</PrimaryBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PrimaryBtn from '../components/LoginPrimaryBtn'
import {loginChoose, loadUserInfo, switchIdentity} from '../servers.js'
import { roleJudge } from '@/pre-init';

export default {
  components: {
    PrimaryBtn
  },
  data() {
    return {
      hasMenu: true
    };
  },

  mounted() {
    let isHideMenu = getQueryString('isHideMenu');
    if (isHideMenu == 1 || this.$fromGyl) {
      this.hasMenu = false;
    }
  },

  methods: {
    // 检验当前登录身份与要跳转的邀请链接是否符合，否则需要调用身份切换接口，然后重新走loadUserInfo2Jump方法
    async checkBindRelationUrlJump(bindRelationUrl, loginIdentity) {

      // 邀请供销商 且登录者是供销商
      // 邀请分销商 且登录者是分销商
      // 就正常跳转
      // 否则需要切换身份后，重新走loadUserInfo2Jump方法
      if (
        (/^\/supplier\/management\/mine/.test(bindRelationUrl) && loginIdentity === 1)
        || (/^\/distributor\/supplier\/mine/.test(bindRelationUrl) && loginIdentity === 2)
      ) {
        this.$router.push(bindRelationUrl)
      } else {
        // 切换身份
        const success = await switchIdentity(loginIdentity === 1 ? 2 : 1);
        if (success) {
          this.jump(loginIdentity === 1 ? 2 : 1)
        }
      }
    },
    async to(n) {
      try {
        const isSuccess = await loginChoose({
          loginIdentity: n
        })
        if (!isSuccess) return ;
        this.jump(n);
      } catch (error) {
        console.log(error)
      }
    },
    async jump(n) {
      try {
        const success = await loadUserInfo()
        const bindRelationUrl = this.$store.getters.bindRelationUrl;
        if (success) {
          if(n==1 || n==2){
            if (bindRelationUrl) {
              this.checkBindRelationUrlJump(bindRelationUrl, n);
            } else {
              const { redirectUrl, ...rest } = this.$route.query;
              this.$router.push({
                path: '/',
                query: rest,
              });
              roleJudge();
            }

            let share_location = sessionStorage.getItem('_share_location_');
            if(share_location){
              location.href = location.origin + JSON.parse(share_location);
            }
          }
          
        } else {
          this.$message.error('获取身份信息失败')
        }
      } catch (error) {
        console.log(error)
      }
      
    },
  }
}
</script>
<style lang="scss" scoped>

.login-choose-layout {
  width: 100vw;
  height: 100vh;
  background: #f6f8fb;
  overflow: hidden;
  .header {
    height: 50px;
    line-height: 50px;
    background: #396CF3;
    color: #fff;
    font-size: 16px;
    text-align: left;
    padding: 0 18px;

    .logo {
      width: 26px;
      height: 26px;
      vertical-align: text-bottom;
      margin-right: 9px;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;

    .title {
      font-size: 20px;
      color: #3c3c3c;
      text-align: center;
    }

    .block-choose {
      display: flex;
      margin-top: 76px;
      .card {
        border: 1px solid #ecf2fb;
        width: 360px;
        height: 480px;
        background: #fff;
        border-radius: 4px;
        cursor: pointer;
        .img {
          height: 236px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 40px;
          
          .supplier {
            height: 148px;
            width: 218px;
          }

          .distributor {
            width: 194px;
            height: 171px;
          }
        }

        .des {
          font-size: 12px;
          color: #9c9c9c;
          margin-top: 10px;
          text-align: center;
        }

        .choose-btn ::v-deep .login-primary-btn {  
          height: 36px;
          line-height: 36px;
          width: 120px;
          text-align: center;
          margin-top: 40px;
          margin-left: auto;
          margin-right: auto;
        }

      }
      .card + .card {
        margin-left: 40px;
      }
    }
  }
}
</style>
